import { APIProvider } from '@vis.gl/react-google-maps'

import { useDateLocale } from '../../../../hooks'

import { GOOGLE_MAP_API_PROVIDER_KEY } from './GoogleMapApiProvider.constants'

function GoogleMapApiProvider({ children }) {
  const { code: locale } = useDateLocale()

  return (
    <APIProvider apiKey={GOOGLE_MAP_API_PROVIDER_KEY} language={locale}>
      {children}
    </APIProvider>
  )
}

export default GoogleMapApiProvider
